import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { Breadcrumbs, Breadcrumb, BreadcrumbLink } from 'legacy/components/Breadcrumbs'
import { type RetailerScopedRouteParams } from 'legacy/common/types'
import { type RetailerRouteComponentProps, type ParsedQuery } from 'legacy/components/RetailerRoute'
import withRouter from 'legacy/common/withRouter'

import { OrderDetailsBackBreadcrumb } from './OrderDetailsBackBreadcrumb'

export interface OrderDetailsBreadcrumbsQueryParams {
  pickup: boolean
}

export interface OrderDetailsBreadcrumbsProps
  extends RetailerRouteComponentProps<
    RetailerScopedRouteParams,
    OrderDetailsBreadcrumbsQueryParams,
    ParsedQuery<OrderDetailsBreadcrumbsQueryParams>
  > {
  orderId: number
}

const OrderDetailsBreadcrumbs: FunctionComponent<OrderDetailsBreadcrumbsProps> = ({
  match: { params },
  query,
  orderId,
}) => {
  const { partner_id, warehouse_id } = params
  delete query.pickup

  return (
    <Breadcrumbs>
      <BreadcrumbLink to={`/partners/${partner_id}/warehouses/${warehouse_id}/orders/delivery`}>
        <FormattedMessage id="orders.title" />
      </BreadcrumbLink>
      <OrderDetailsBackBreadcrumb
        deliveryUrl={`/partners/${partner_id}/warehouses/${warehouse_id}/orders/delivery`}
        pickupUrl={`/partners/${partner_id}/warehouses/${warehouse_id}/orders/pickup`}
        isPickup={query.pickup}
        query={query}
      />
      {orderId && <Breadcrumb>{orderId}</Breadcrumb>}
    </Breadcrumbs>
  )
}

export default withRouter(OrderDetailsBreadcrumbs)
